// extracted by mini-css-extract-plugin
module.exports = {"SpinnerGlobal":"SpinnerGlobal_SpinnerGlobal__2eljp","spinner":"SpinnerGlobal_spinner__3QYdy","load8":"SpinnerGlobal_load8__2xqjc"};